define('subscribePage',['jquery'],
    function ($) {
        var $subscribeContainer = $('#subscribe');
        var $unsubscribeContainer = $('#unsubscribe');

        if ($subscribeContainer.length) {
            subscribeFlow();
        } else if ($unsubscribeContainer.length) {
            unsubscribeFlow();
        }

        function subscribeFlow() {
            var $magazineSection = $('.subscribe-magazine'),
                $rootForm = $('.root-form'),
                $checkboxContainer = $('.subscribe__checkboxes'),
                $checkboxesThatTriggerMagazine = $('.subscribe__checkboxes span[data-trigger]').parent().siblings('input'),
                $checkboxPrint = $('#cbTrykt'),
                $checkboxOnline = $('#cbOnline'),
                $textInputSection = $('.subscribe-magazine__text-inputs'),
                $textInputs = $textInputSection.find('input'),
                $requiredTextInputs = $textInputSection.find('input[data-required]'),
                $backLink = $('.subscribe-magazine__back-link'),
                magazineIsOpen = false,
                $captchaCheck = $('.captcha__check');

            // Checks if any of the magazine triggering subjects has been checked
            function checkForMagazineTriggers() {
                //var triggerMagazine = false;
                //$checkboxesThatTriggerMagazine.each(function (index, checkbox) {
                //    if (checkbox.checked) {
                //        triggerMagazine = true;
                //    }
                //});
                return true; // always true
            }


            // Close the magazine section & open the subject section
            $backLink.on("click", function (event) {
                event.preventDefault();
                magazineIsOpen = false;
                $textInputs.val("");
                $checkboxPrint.prop("checked", false);
                $checkboxOnline.prop("checked", false);
                $requiredTextInputs.attr('required', false);
                $magazineSection.slideUp({ complete: function () { $checkboxContainer.slideDown() } });
            });

            $rootForm.on("submit", function (event) {
                if (!isReCaptchaChecked()) {
                    event.preventDefault();

                    $captchaCheck.addClass('captcha__check--visible');
                    return;
                } else {
                    $captchaCheck.removeClass('captcha__check--visible');
                }

                // If either of the checkboxes that trigger Magazine are checked, then don't submit yet
                if (checkForMagazineTriggers() && !magazineIsOpen) {
                    event.preventDefault();
                    magazineIsOpen = true;
                    setRequiredInputs($checkboxPrint[0]);

                    $checkboxContainer.slideUp({
                        complete: function () {
                            $magazineSection.slideDown(
                                {
                                    complete: function () {
                                        $([document.documentElement, document.body]).animate({
                                            scrollTop: $magazineSection.offset().top
                                        }, 0);
                                    }
                                }

                            )
                        }
                    });
                }
            });

            function isReCaptchaChecked() {
                var $reCaptcha = $('.g-recaptcha-response');

                return $reCaptcha.val() !== "";
            }

            $checkboxPrint.on('change', function () {
                setRequiredInputs(this);
            });

            function setRequiredInputs(checkbox) {
                if (checkbox.checked) {
                    $textInputSection.slideDown();
                    $requiredTextInputs.attr('required', true);
                } else {
                    $textInputSection.slideUp();
                    $requiredTextInputs.attr('required', false);
                }
            }
        }

        function unsubscribeFlow() {
            var $unsubscribeForm = $('.root-form'),
                $mailInput = $('.unsubscribe__input'),
                $submitButton = $('.unsubscribe__submit'),
                $responseContainer = $('.unsubscribe__response span');

            var apiUrl = '/api/EmailPlatformUnsubscribe/Unsubscribe?email=';

            $unsubscribeForm.on('submit', function (e) {
                e.preventDefault();

                $submitButton.addClass('loading');

                $.ajax({
                    url: apiUrl + encodeURIComponent($mailInput.val()),
                    type: 'GET',
                    success: function (response) {
                        $submitButton.removeClass('loading');
                        $responseContainer.html(response);
                    },
                    error: function (response) {
                        $submitButton.removeClass('loading');
                        $responseContainer.html(response.statusText);
                    }
                });
            });
        }


        // Landingpage functions

        var $subscribeContainer = $('#subscribe2');

        if ($subscribeContainer.length) {
            subscribeFlow2();
        }

        function subscribeFlow2() {
            var $magazineSection = $('.subscribe-magazine'),
                $rootForm = $('.root-form'),
                $checkboxContainer = $('.subscribe__checkboxes'),
                $checkboxesThatTriggerMagazine = $('.subscribe__checkboxes span[data-trigger]').parent().siblings('input'),
                $checkboxPrint = $('#cbTrykt'),
                $checkboxOnline = $('#cbOnline'),
                $textInputSection = $('.subscribe-magazine__text-inputs'),
                $textInputs = $textInputSection.find('input'),
                $requiredTextInputs = $textInputSection.find('input[data-required]'),
                $backLink = $('.subscribe-magazine__back-link'),
                magazineIsOpen = false,
                $captchaCheck = $('.captcha__check');

            // Close the magazine section & open the subject section
            $backLink.on("click", function (event) {
                event.preventDefault();
                magazineIsOpen = false;
                $textInputs.val("");
                $checkboxPrint.prop("checked", false);
                $checkboxOnline.prop("checked", false);
                $requiredTextInputs.attr('required', false);
                $magazineSection.slideUp({ complete: function () { $checkboxContainer.slideDown() } });
            });

            //$rootForm.on("submit", function (event) {
            $(".signup2").on("click", function (event) {
                if (!isReCaptchaChecked()) {
                    event.preventDefault();

                    $captchaCheck.addClass('captcha__check--visible');
                    return;
                } else {
                    $captchaCheck.removeClass('captcha__check--visible');
                }

                // If either of the checkboxes that trigger Magazine are checked, then don't submit yet
                if (!magazineIsOpen) {
                    event.preventDefault();
                    magazineIsOpen = true;
                    setRequiredInputs($checkboxPrint[0]);

                    $checkboxContainer.slideUp({
                        complete: function () {
                            $magazineSection.slideDown(
                                {
                                    complete: function () {
                                        $([document.documentElement, document.body]).animate({
                                            scrollTop: $magazineSection.offset().top
                                        }, 0);
                                    }
                                }

                            )
                        }
                    });
                }
            });

            function isReCaptchaChecked() {
                var $reCaptcha = $('.g-recaptcha-response');

                return $reCaptcha.val() !== "";
            }

            $checkboxPrint.on('change', function () {
                setRequiredInputs(this);
            });

            function setRequiredInputs(checkbox) {
                if (checkbox) {
                    if (checkbox.checked) {
                        $textInputSection.slideDown();
                        $requiredTextInputs.attr('required', true);
                    } else {
                        $textInputSection.slideUp();
                        $requiredTextInputs.attr('required', false);
                    }
                }
            }
        }

    }
);
